import Component404 from '../components/_molecules/Component404';
import { NextPageWithLayout } from '../components/layouts';
import LandingPageLayout from '../components/layouts/LandingPageLayout';
const LandingPage404: NextPageWithLayout = () => {
  return (
    <LandingPageLayout
      title="Curipod Live"
      subTitle="Make question asking fun and interactive in the classroom"
      primaryActionText="Sign up - It's free"
      disableHeadline={true}
    >
      <Component404 />
    </LandingPageLayout>
  );
};

export default LandingPage404;
